import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Pricing from "components/pricing/ThreePlansStatic";
// import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
import Footer from "components/footers/MiniCenteredFooter.js";
function App() {
  
	return (
    <><AnimationRevealPage>
      <Header />
      <Pricing />
      <Footer />
    </AnimationRevealPage>
    </>
	)
}

export default App
